define("auth/templates/update_password", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="tSU--container">
    {{! Card }}
    <div class="tSU--card">
      <h1 class="tSU--card__title u--m__b">{{t "shared_phrases.reset_password"}}</h1>
      <p class="u--text--md u--m__b__lg">{{t "reset_password.subheader"}}</p>
      {{! Form objects }}
      <form {{on "submit" (perform this.resetPassword)}}>
        <div class="o--formWrapper--lg">
          <label for="new password">{{t "reset_password.new_password"}}</label>
          <Input
            @type="password"
            @value={{this.newPassword}}
            class="o--form__input"
            id="new password"
            placeholder={{t "reset_password.new_password_placeholder"}}
            required="true"
            {{autofocus}}
          />
        </div>
        <div class="o--formWrapper--lg">
          <label for="confirm password">{{t "reset_password.confirm_new_password"}}</label>
          <Input
            @type="password"
            @value={{this.confirmNewPassword}}
            class="o--form__input"
            id="confirm password"
            placeholder={{t "reset_password.confirm_new_password_placeholder"}}
            required="true"
          />
        </div>
        <div class="o--formSubmit">
          <Shared::Ui::Button
            @additional="block"
            @isDisabled={{this.resetPassword.isRunning}}
            @size="large"
            @text={{t "reset_password.change_password"}}
            type="submit"
          />
        </div>
        {{#if this.resetPassword.isRunning}}
          <Shared::LoadingSpinner @additionalClass="tSU--loadingSpinner" />
        {{/if}}
      </form>
    </div>
  </div>
  */
  {
    "id": "v9eCklSe",
    "block": "[[[10,0],[14,0,\"tSU--container\"],[12],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"tSU--card\"],[12],[1,\"\\n    \"],[10,\"h1\"],[14,0,\"tSU--card__title u--m__b\"],[12],[1,[28,[35,0],[\"shared_phrases.reset_password\"],null]],[13],[1,\"\\n    \"],[10,2],[14,0,\"u--text--md u--m__b__lg\"],[12],[1,[28,[35,0],[\"reset_password.subheader\"],null]],[13],[1,\"\\n\"],[1,\"    \"],[11,\"form\"],[4,[38,1],[\"submit\",[28,[37,2],[[30,0,[\"resetPassword\"]]],null]],null],[12],[1,\"\\n      \"],[10,0],[14,0,\"o--formWrapper--lg\"],[12],[1,\"\\n        \"],[10,\"label\"],[14,\"for\",\"new password\"],[12],[1,[28,[35,0],[\"reset_password.new_password\"],null]],[13],[1,\"\\n        \"],[8,[39,3],[[24,0,\"o--form__input\"],[24,1,\"new password\"],[16,\"placeholder\",[28,[37,0],[\"reset_password.new_password_placeholder\"],null]],[24,\"required\",\"true\"],[4,[38,4],null,null]],[[\"@type\",\"@value\"],[\"password\",[30,0,[\"newPassword\"]]]],null],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"o--formWrapper--lg\"],[12],[1,\"\\n        \"],[10,\"label\"],[14,\"for\",\"confirm password\"],[12],[1,[28,[35,0],[\"reset_password.confirm_new_password\"],null]],[13],[1,\"\\n        \"],[8,[39,3],[[24,0,\"o--form__input\"],[24,1,\"confirm password\"],[16,\"placeholder\",[28,[37,0],[\"reset_password.confirm_new_password_placeholder\"],null]],[24,\"required\",\"true\"]],[[\"@type\",\"@value\"],[\"password\",[30,0,[\"confirmNewPassword\"]]]],null],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"o--formSubmit\"],[12],[1,\"\\n        \"],[8,[39,5],[[24,4,\"submit\"]],[[\"@additional\",\"@isDisabled\",\"@size\",\"@text\"],[\"block\",[30,0,[\"resetPassword\",\"isRunning\"]],\"large\",[28,[37,0],[\"reset_password.change_password\"],null]]],null],[1,\"\\n      \"],[13],[1,\"\\n\"],[41,[30,0,[\"resetPassword\",\"isRunning\"]],[[[1,\"        \"],[8,[39,7],null,[[\"@additionalClass\"],[\"tSU--loadingSpinner\"]],null],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[],false,[\"t\",\"on\",\"perform\",\"input\",\"autofocus\",\"shared/ui/button\",\"if\",\"shared/loading-spinner\"]]",
    "moduleName": "auth/templates/update_password.hbs",
    "isStrictMode": false
  });
});